module.exports = __webpack_public_path__ + "assets/milk2-token.310ec0f0.svg";